// File Operations — pure UI helpers for file selection/display.
// No backend calls happen here. Processing occurs in chatWithAI on message send.

const ACCEPTED_EXTENSIONS = ['.pdf', '.xlsx', '.xls', '.csv'];

function isAcceptedFile(file) {
  const ext = (file.name || '').split('.').pop().toLowerCase();
  return ACCEPTED_EXTENSIONS.includes(`.${ext}`);
}

export const handleFileUpload = (e, setUploadedFile, setShowUploadPopup) => {
  const file = e.target.files[0];
  if (file && isAcceptedFile(file)) {
    setUploadedFile(file);
    setShowUploadPopup(false);
  }
};

export const handleFileDrop = (e, setUploadedFile, setShowUploadPopup) => {
  e.preventDefault();
  const file = e.dataTransfer.files[0];
  if (file && isAcceptedFile(file)) {
    setUploadedFile(file);
    setShowUploadPopup(false);
  }
};

export const handleDragOver = (e) => {
  e.preventDefault();
};

export const removeUploadedFile = (setUploadedFile) => {
  setUploadedFile(null);
};

/**
 * File operations factory — creates bound functions with all dependencies
 */
export const createFileOperations = ({ setUploadedFile, setShowUploadPopup }) => ({
  handleFileUpload: (e) => handleFileUpload(e, setUploadedFile, setShowUploadPopup),
  handleFileDrop: (e) => handleFileDrop(e, setUploadedFile, setShowUploadPopup),
  handleDragOver,
  removeUploadedFile: () => removeUploadedFile(setUploadedFile),
});
